import { Injector } from '@angular/core';
import { AsyncValidatorFn, ValidatorFn } from '@angular/forms';
import { CustomValidatorConfig, CustomValidators } from '@finxone-platform/shared/sys-config-types';
import { MustMatchRadioOptionValidator } from './must-match-radio-option.validator';
import { NameIsFirstAndLastValidator } from './name-is-first-and-last.validator';
import { SavingsBalanceValidator } from './savings-balance.validator';

export function createCustomValidators(
  validators: CustomValidatorConfig[],
  injector: Injector,
): AsyncValidatorFn[] {
  return validators
    .map((config) => {
      switch (config.type) {
        // if you have async validators, add cases here
        default:
          return null;
      }
    })
    .filter((validator) => validator !== null) as unknown as AsyncValidatorFn[];
}

export function createSyncCustomValidators(
  validators: CustomValidatorConfig[],
  injector: Injector,
): ValidatorFn[] {
  return validators
    .map((config) => {
      switch (config.type) {
        case CustomValidators.SAVINGS_BALANCE_VALIDATOR:
          return new SavingsBalanceValidator(injector).createSyncFromConfig(config);
        case CustomValidators.NAME_IS_FIRST_AND_LAST_VALIDATOR:
          return new NameIsFirstAndLastValidator().createSyncFromConfig(config);
        case CustomValidators.MUST_MATCH_RADIO_OPTION_VALIDATOR:
          return new MustMatchRadioOptionValidator().createSyncFromConfig(config);
        default:
          return null;
      }
    })
    .filter((validator): validator is ValidatorFn => validator !== null);
}
